import uuid from '../utils/uuid.utils';

export class MicroBlinkEvent {
  static open(extraData = null) {
    window.__CAAS__.triggerNative(
      window.__CAAS__.events.callMicroblink,
      uuid(),
      extraData,
    );
  }
}
